"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDatasetShareAcceptData = exports.setDatasetShareAcceptData = exports.getDatasetShareAcceptData = exports.mkDatasetShareAcceptData = void 0;
const immutable_1 = require("immutable");
const core_1 = require("companion-app-components/utils/core");
const dataKey = 'share-accept-data';
exports.mkDatasetShareAcceptData = (0, immutable_1.Record)({
    isGranteeNewUser: false,
    granteeEmail: undefined,
    datasetId: undefined,
    used: 1,
});
const getDatasetShareAcceptData = () => {
    const data = core_1.localPreferences.getItem(dataKey);
    return data ? (0, exports.mkDatasetShareAcceptData)(data) : null;
};
exports.getDatasetShareAcceptData = getDatasetShareAcceptData;
const setDatasetShareAcceptData = (data) => {
    core_1.localPreferences.setItem(dataKey, {
        granteeEmail: data.granteeEmail,
        isGranteeNewUser: data.isGranteeNewUser,
        datasetId: data.datasetId,
        used: data.used,
    });
};
exports.setDatasetShareAcceptData = setDatasetShareAcceptData;
const removeDatasetShareAcceptData = () => {
    core_1.localPreferences.removeItem(dataKey);
};
exports.removeDatasetShareAcceptData = removeDatasetShareAcceptData;
